import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileName", "labelGroup", "labelInput", "typeSelect"]
  static values = {
    noFileSelected: String,
    defaultLabelPlaceholder: String,
    otherLabelPlaceholder: String
  }

  connect() {
    this.updateFileName()
    this.updateTypeSelection()
  }

  updateFileName() {
    if (!this.hasFileNameTarget) return

    const file = this.hasFileInputTarget ? this.fileInputTarget.files[0] : null
    this.fileNameTarget.textContent = file ? file.name : this.noFileSelectedValue
  }

  updateTypeSelection() {
    this.updateLabelVisibility()
    this.updateLabelPlaceholder()
  }

  updateLabelVisibility() {
    if (!this.hasLabelGroupTarget || !this.hasTypeSelectTarget) return

    if (this.typeSelectTarget.value === "other") {
      this.labelGroupTarget.classList.remove("u-hidden")
      return
    }

    this.labelGroupTarget.classList.add("u-hidden")
  }

  updateLabelPlaceholder() {
    if (!this.hasLabelInputTarget || !this.hasTypeSelectTarget) return

    if (this.typeSelectTarget.value === "other") {
      this.labelInputTarget.placeholder = this.otherLabelPlaceholderValue
      return
    }

    this.labelInputTarget.placeholder = this.defaultLabelPlaceholderValue
  }
}
